var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.0549V12.9549H16.6C16.8 12.9549 16.9 13.1549 16.9 13.3549L16.5 15.2549C16.5 15.3549 16.3 15.4549 16.2 15.4549H14V22.7549H11V15.5549H9.3C9.1 15.5549 9 15.4549 9 15.2549V13.3549C9 13.1549 9.1 13.0549 9.3 13.0549H11V9.75488C11 8.05488 12.3 6.75488 14 6.75488H16.7C16.9 6.75488 17 6.85488 17 7.05488V9.45488C17 9.65488 16.9 9.75488 16.7 9.75488H14.3C14.1 9.75488 14 9.85488 14 10.0549Z",
    stroke: "#BA1F1A",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.7549H9C4 22.7549 2 20.7549 2 15.7549V9.75488C2 4.75488 4 2.75488 9 2.75488H15C20 2.75488 22 4.75488 22 9.75488V15.7549C22 20.7549 20 22.7549 15 22.7549Z",
    stroke: "#BA1F1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.54a5aca882cb92444fa529587f8bec6a.svg";
export { ForwardRef as ReactComponent };